import type { ThemeOptions } from "@mui/material";

export const CREThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#09253e",
    },
    secondary: {
      main: "#e7184e",
    },
    background: {
      default: "#E6EBF0",
      paper: "#FAFAFA",
    },
  },
};
